import { render, staticRenderFns } from "./MyChat.vue?vue&type=template&id=70f94b96&scoped=true&"
import script from "./MyChat.vue?vue&type=script&lang=js&"
export * from "./MyChat.vue?vue&type=script&lang=js&"
import style0 from "./MyChat.vue?vue&type=style&index=0&id=70f94b96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f94b96",
  null
  
)

export default component.exports